import { useParams } from 'react-router-dom';
import HTMLReport from '../../Reporting/HTMLReport';

export default function BaggingReport() {
    const { lotNumber } = useParams();

    let url = `api/v1/lot/${lotNumber}/lotsplitreport`;
    let downloadName = `${lotNumber}-bagging-report.html`;

    return (
        <HTMLReport url={url} downloadName={downloadName}></HTMLReport>
    )
}
